import {formatCurrency} from "../../common/Utils";

function GiftCardBody({
                        backgroundStyle,
                        giftCardRecipient,
                        giftCardFrom,
                        giftCardBalance,
                        giftCardQrCode,
                        companyName,
                        giftCardMessage,
                        giftCardCode,
                        giftCardLink,
                      }) {
  const infoBoxStyle = {
    padding: '20px',
    fontSize: '22px',
    width: '100%',
    border: 'solid 1px #ddd',
    borderRadius: '50px',
    background: '#fff',
    margin: '12px 0',
  };

  return (
    <div
      style={{
        ...backgroundStyle,
        border: 'solid 2px #ddd',
        borderRadius: '22px',
        padding: '60px 12px 60px 12px',
      }}
    >
      <div style={{width: 'auto', margin: '0 auto'}}>
        <h1
          style={{
            color: '#fff',
            textShadow: '0px 0px 5px rgba(0,0,0,0.5)',
            textAlign: 'center',
          }}
        >
          Gift Card
        </h1>

        <div style={infoBoxStyle}>
          To: <b>{giftCardRecipient}</b>
        </div>

        {giftCardFrom && <div style={infoBoxStyle}>
          From: <b>{giftCardFrom}</b>
        </div>
        }


        <div style={infoBoxStyle}>
          Amount: <b>{formatCurrency(giftCardBalance)}</b>
        </div>
      </div>

      <table
        role="presentation"
        cellPadding={0}
        cellSpacing={0}
        border={0}
        width="100%"
        style={{
          width: '100%',
          maxWidth: '600px',
          margin: '0 auto',
          border: '1px solid #dedede',
          borderRadius: '10px',
          backgroundColor: '#ffffff',
        }}
      >
        <tbody>
        <tr>
          <td
            width={180}
            valign="middle"
            style={{
              width: '130px',
              padding: '16px 10px 16px 16px',
              verticalAlign: 'middle',
            }}
          >
            <table
              role="presentation"
              cellPadding={0}
              cellSpacing={0}
              border={0}
              width="125"
              style={{
                width: '125px',
                backgroundColor: '#f5f1ea',
                borderRadius: '8px',
              }}
            >
              <tbody>
              <tr>
                <td
                  align="center"
                  valign="middle"
                  style={{
                    padding: '7px',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                >
                  {giftCardQrCode}
                </td>
              </tr>
              </tbody>
            </table>
          </td>

          <td
            valign="middle"
            style={{
              padding: '16px 20px 16px 8px',
              verticalAlign: 'middle',
              fontFamily: 'Arial, Helvetica, sans-serif',
            }}
          >
            <div
              style={{
                fontSize: '12px',
                lineHeight: '18px',
                color: '#888888',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
              }}
            >
              {companyName} Gift Card
            </div>

            <div
              style={{
                fontSize: '20px',
                lineHeight: '28px',
                fontWeight: 'bold',
                color: '#222222',
              }}
            >
              {formatCurrency(giftCardBalance)}
            </div>

            <div
              style={{
                fontSize: '13px',
                lineHeight: '14px',
                color: '#666666',
              }}
            >
              For {giftCardRecipient}
              <br/>
              <p>{giftCardMessage}</p>
            </div>

            <div
              style={{
                fontSize: '12px',
                lineHeight: '18px',
                color: '#999999',
                marginTop: '4px',
              }}
            >
              Redemption Code <b>{giftCardCode}</b>
            </div>
          </td>
        </tr>

        <tr>
          <td colSpan={3}>
            <table
              role="presentation"
              cellPadding={0}
              cellSpacing={0}
              border={0}
              width="100%"
              style={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '8px',
                maxWidth: '600px',
              }}
            >
              <tbody>
              <tr>
                <td
                  align="center"
                  valign="middle"
                  style={{
                    padding: '7px',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                >
                  <div
                    style={{
                      fontSize: '12px',
                      lineHeight: '14px',
                      color: '#111',
                      width: '100%',
                      textAlign: 'center',
                    }}
                  >
                    {giftCardLink}
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
}

export default GiftCardBody;